import { createSvgIcon } from "@mui/material/utils";

export default createSvgIcon(
  <path
    d="M19 7H22L18 3L14 7H17V21H19V7ZM2 17H12V19H2V17ZM6 5V7H2V5H6ZM2 11H9V13H2V11Z"
    xmlns="http://www.w3.org/2000/svg"
  />,
  "SortUp"
);
